
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_condoleanceregisterprovinciegelderland",
      function () {
        return require("private-next-pages/_sites/_condoleanceregisterprovinciegelderland/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_condoleanceregisterprovinciegelderland"])
      });
    }
  